import React from 'react';
import { Controller } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { FormFeedback, Input } from 'reactstrap';
import { fetchHRCodeList } from '../../../store/apis/commonService';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function HRCodeListSelectElement({
  formMethods,
  name,
  type = 'COMPANY',
  cc = null,
  formType,
  title,
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  const { data: entityOptions = [] } = useQuery({
    queryKey: [name],
    queryFn: () => fetchHRCodeList({ type, param4: cc || null }),
    enabled: true,
  });

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type="select"
            name={name}
            className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
            title={title}
          >
            <option value="">-- Select One --</option>
            {entityOptions.map(dep => (
              <option key={dep.Code} value={dep.Code.trim()}>
                {dep.Description}
              </option>
            ))}
          </Input>
        )}
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]?.message}</FormFeedback>}
    </>
  );
}
